import React from 'react';
import PropTypes from 'prop-types';

import LayoutIntern from '../layout-intern';

const WrapperPageIntern = ({ component }) => (
  <LayoutIntern>
    {component}
  </LayoutIntern>
);

WrapperPageIntern.propTypes = {
  component: PropTypes.node.isRequired,
};

export default WrapperPageIntern;
